var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GetReturnportalParcelnumberContainers.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-59477505\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GetReturnportalParcelnumberContainers.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/GetReturnportalParcelnumberContainers.vue
// module id = 895
// module chunks = 1